import { render, staticRenderFns } from "./info.vue?vue&type=template&id=2b6c85dd&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=2b6c85dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c85dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6c85dd')) {
      api.createRecord('2b6c85dd', component.options)
    } else {
      api.reload('2b6c85dd', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=2b6c85dd&scoped=true&", function () {
      api.rerender('2b6c85dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/info.vue"
export default component.exports